import { FC, useEffect, useState, Dispatch } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { UserDecisionInterface } from "../../../middleware/interfaces/user/user-decision-interface";

interface viewerOptionDialogProps {
  decision: UserDecisionInterface | null | undefined;
  dispatch: Dispatch<any>;
}

const ViewerOptionDialog: FC<viewerOptionDialogProps> = ({
  decision,
  dispatch,
}) => {
  const [standardViewer, setStandardViewer] = useState(false);
  const [fourDimensionViewer, setFourDimensionViewer] = useState(false);
  const [mapViewer, setMapViewer] = useState(false);
  const [back, setBack] = useState(false);

  useEffect(() => {
    if (standardViewer) {
      decision!.result = "STANDARD";
      dispatch({ type: "DECISION", decision: decision });
    }
    setStandardViewer(false);
  }, [standardViewer]);

  useEffect(() => {
    if (fourDimensionViewer) {
      decision!.result = "4D";
      dispatch({ type: "DECISION", decision: decision });
    }
    setFourDimensionViewer(false);
  }, [fourDimensionViewer]);

  useEffect(() => {
    if (mapViewer) {
      decision!.result = "MAP";
      dispatch({ type: "DECISION", decision: decision });
    }
    setMapViewer(false);
  }, [mapViewer]);

  useEffect(() => {
    if (back) {
      decision = null;
      dispatch({ type: "DECISION", decision: decision });
    }
    setBack(false);
  }, [back]);

  return (
    <>
      {(() => {
        if (
          decision !== null &&
          decision !== undefined &&
          decision.imageOptions === true &&
          decision.result === ""
        ) {
          return (
            <div className="dialogCover" onClick={StopEventPropagation}>
              <div className="dialog">
                <div className="dialogHeader">
                  <div className="dialogHeading">
                    <h2 className="dialogTitle">{decision?.title}</h2>
                    <span className="dialogSubtitle">{decision?.message}</span>
                  </div>
                  <span
                    className="dialogClose"
                    onClick={() => {
                      setBack(true);
                    }}
                  >
                    ×
                  </span>
                </div>
                {/* the picker is the dialog: each viewer is its own row, so
                    the choice is named rather than guessed from a glyph. Only
                    the viewers the decision offers get a row. */}
                <div className="dialogBody dialogOptionList">
                  {decision.decisionOptions.includes("STANDARD") && (
                    <div
                      className="dialogCheckRow"
                      onClick={() => {
                        setStandardViewer(true);
                      }}
                    >
                      <img
                        src="assets/icons/standard-viewer.png"
                        draggable="false"
                        alt="Standard viewer"
                      />
                      <span className="dialogCheckRowLabel">
                        Standard viewer
                      </span>
                    </div>
                  )}
                  {decision.decisionOptions.includes("4D") && (
                    <div
                      className="dialogCheckRow"
                      onClick={() => {
                        setFourDimensionViewer(true);
                      }}
                    >
                      <img
                        src="assets/icons/4d-viewer.png"
                        draggable="false"
                        alt="4D viewer"
                      />
                      <span className="dialogCheckRowLabel">4D viewer</span>
                    </div>
                  )}
                  {decision.decisionOptions.includes("MAP") && (
                    <div
                      className="dialogCheckRow"
                      onClick={() => {
                        setMapViewer(true);
                      }}
                    >
                      <img
                        src="assets/icons/map-viewer.png"
                        draggable="false"
                        alt="Map viewer"
                      />
                      <span className="dialogCheckRowLabel">Map viewer</span>
                    </div>
                  )}
                </div>
                <div className="dialogButtonWrapper">
                  <input
                    type="button"
                    name="cancel"
                    value="Cancel"
                    onClick={() => {
                      setBack(true);
                    }}
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default ViewerOptionDialog;
